import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { KbLoadingService } from '../sapSpartacus/loading.service';

export const urlsToCheck: { [key: string]: boolean } = {
  kbsearch: true,
  'current/carts': true,
  order: true,
  compare: true,
  cartId: true,
  addressbook: true,
  'mycompnay/getmycompanyuser': true,
  '/mycompnay/disable': true,
  '/mycompnay/enable': true,
  corelookup: true,
  mytickets: true,
  'mycompnay/edit': true,
  'mywarranty/submitNaAttachments': true,
  'mywarranty/finalreview': true,
  'mywarranty/uploadtest?': true,
  'mywarranty/warrantysubmit': true,
  'mywarranty/getDealerCode': true,
  'mywarranty/getProductForCustomPartNA': true,
  'kbsave?saveCartDescription': true,
  brakeapplication: true,
  'mywarranty/warrantysearch': true,
  'mywarranty/getwarrantysearch': true,
  'products/steering/searchresult': true,
  'mycore/coresearch': true,
  'mycore/coresubmit': true,
  '/myaccount/open-positions': true,
  'mysavedcart/deleteEntries': true,
  'mysavedcart/saved-carts': true,
  mydocuments: true,
  softwareLibrary: true,
  '/products/search': true,
  '/products': true,
  'quote/myquotes': true,
  'quote/deleteEntry': true,
  'quote/cancel': true,
  'myaccount/updateprofile': true,
  'enduraSurePro/sentemail': true,
  'airDiscBrake/sentemail': true,
  'formulablue/searchresult': true,
  'oauth/token': true,
  '/backofficepasswordreset/requestbackofficeuser': true,
  getNotifications: true,
  updateNotification: true,
  '/DTCSearch/type': true,
  dataExtraction: true,
  'headerdata?': true,
  'restoresavedcart': true,
  'importorder?orderType': true,
  'savetoexistingcart?': true,
  '/bulkremove?&entryNumbers': true,
  '/users/current/carts': true,
  '/checkout?mergeRequired=': true,
  '/selectaddress?poNumber=': true,
  '/deliverymethod?selectedCarrierType': true,
  '/review?': true,
  'mydemo/registerDemoUser': true,
  'mydemo/demos': true,
  'dataExtraction/vehicleDetails?': true
};

@Injectable({ providedIn: 'root' })
export class LoadingInterceptor implements HttpInterceptor {
  constructor(protected loadingService: KbLoadingService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (Object.keys(urlsToCheck).some((url) => request.url.includes(url))) {
      if (this.loadingService.FromSearchBox) {
        this.loadingService.setLoading(true, request.url);
      }
    }
    return next
      .handle(request)
      .pipe(
        catchError((err) => {
          this.loadingService.setLoading(false, request.url);
          return throwError(err);
        })
      )
      .pipe(
        map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
          if (evt instanceof HttpResponse) {
            this.loadingService.setLoading(false, request.url);
          }
          return evt;
        })
      )
      .pipe(finalize(() => this.loadingService.setLoading(false, request.url)));
  }
}
